// Central content extracted & adapted from the company intro deck.

export const COMPANY = {
  name: "Shree Yamunesh Software Solutions",
  short: "Shree Yamunesh",
  founder: "Dr. Nishant Zaveri",
  role: "Proprietor · Technical Architect",
  tagline:
    "Empowering global connectivity through seamless enterprise integration.",
  email: "nishant@shreeyamuneshsoftware.com",
  phone: "+91 9029030063",
  address: "4B7, Majithia Nagar, S.V. Road, Kandivali West, Mumbai 400067",
};

export const NAV = [
  { label: "Firm", href: "#about" },
  { label: "Ethos", href: "#manifesto" },
  { label: "Capabilities", href: "#services" },
  { label: "Impact", href: "#metrics" },
  { label: "Contact", href: "#contact" },
];

export const HERO_LINES = [
  "Seamless",
  "integration,",
  "engineered.",
];

export const ABOUT = {
  overline: "01 — The Firm",
  heading: "The architect of enterprise integration.",
  bio: [
    "Shree Yamunesh Software Solutions is a specialist enterprise-integration practice led by Dr. Nishant Zaveri, Technical Architect. We design, build and maintain the connective tissue between complex systems.",
    "Using webMethods and Boomi, we deliver seamless integration solutions that move data with precision — maximizing throughput, interoperability and operational agility for Fortune 500 clients.",
  ],
  stats: [
    { k: "Platforms", v: "webMethods · Boomi" },
    { k: "Sectors", v: "Logistics · Health · Agri" },
    { k: "Delivery", v: "~3 months to ROI" },
  ],
};

export const MANIFESTO = [
  {
    no: "01",
    title: "Vision",
    body: "Empowering businesses through innovative software solutions and seamless integrations for efficient global connectivity.",
  },
  {
    no: "02",
    title: "Mission",
    body: "To provide cutting-edge IT solutions that enhance operational efficiency and foster long-term partnerships with our clients.",
  },
  {
    no: "03",
    title: "Values",
    body: "Integrity, Innovation, Customer Focus, Collaboration and Excellence are the core principles guiding every decision we make.",
  },
];

export const CLIENTS = [
  "DHL",
  "Boston Scientific",
  "Advatix",
  "Dairy Farmers of America",
  "Toll Logistics",
  "Archway",
];

export const SERVICES = [
  {
    no: "01",
    title: "Integrations",
    body: "Seamless integration solutions built on webMethods and Boomi that enhance operational efficiency for Fortune 500 clients like DHL and Boston Scientific.",
  },
  {
    no: "02",
    title: "Consulting",
    body: "Domain-led advisory on integration architecture — customized, standards-driven solutions aligned to business goals and regulatory compliance.",
  },
  {
    no: "03",
    title: "Support",
    body: "Ongoing support and maintenance for live integrations, enabling continuous optimization and rapid resolution to keep systems stable.",
  },
];

export const TECH = [
  {
    name: "webMethods",
    desc: "Tailored integrations and automated data workflows. Typical implementation completes within three months — accelerating ROI.",
    image:
      "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxzZXJ2ZXIlMjByb29tJTIwYmx1ZSUyMGxpZ2h0cyUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzg1ODY3NDk5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Boomi",
    desc: "Cloud-native architecture that scales for high transaction volumes with real-time data visibility for sharper decision-making.",
    image:
      "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyYWwlMjBzdHJ1Y3R1cmUlMjBoaWdoJTIwY29udHJhc3R8ZW58MHx8fHwxNzg1ODY3NDk5fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const METRICS = [
  { value: 30, suffix: "%", label: "Faster processing", note: "DHL logistics integration" },
  { value: 25, suffix: "%", label: "Cost savings", note: "Average annual, per client" },
  { value: 99, suffix: "%", label: "System uptime", note: "Across implementations" },
  { value: 2, suffix: "%", label: "Error rate", note: "Post-integration monitoring" },
];

export const PROCESS = [
  { no: "01", title: "Assess", body: "Evaluate existing systems to surface integration gaps and legacy constraints." },
  { no: "02", title: "Design", body: "Develop an integration architecture tailored precisely to your operational needs." },
  { no: "03", title: "Implement", body: "Execute the integration with minimal disruption to live production systems." },
  { no: "04", title: "Review", body: "Monitor performance continuously and optimize integration processes over time." },
];

export const INDUSTRIES = [
  {
    no: "01",
    name: "Logistics",
    body: "Streamlining supply-chain data flow for global carriers like DHL and Toll Logistics.",
    image:
      "https://images.unsplash.com/photo-1556011308-d6aedab5ed8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxkaGwlMjBkZWxpdmVyeSUyMHRydWNrfGVufDB8fHx8MTc4NTg2NzUwOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "02",
    name: "Healthcare",
    body: "Compliant, reliable integrations for medical-technology leaders like Boston Scientific.",
    image:
      "https://images.unsplash.com/photo-1516549655169-df83a0774514?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG1vZGVybiUyMG1lZGljYWwlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4NTg2NzQ5OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "03",
    name: "Agriculture",
    body: "Scalable, future-proof systems enabling growth for clients like Dairy Farmers of America.",
    image:
      "https://images.unsplash.com/photo-1615811361523-6bd03d7748e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxoaWdoJTIwdGVjaCUyMGFncmljdWx0dXJlJTIwdHJhY3RvcnxlbnwwfHx8fDE3ODU4Njc1MTB8MA&ixlib=rb-4.1.0&q=85",
  },
];
